<template>
  <FileFolderTabs :tabs="tabs" :current="current" />
</template>

<script>
export default {
  props: {
    current: { type: String, default: "" },
  },
  computed: {
    tabs() {
      return [
        {
          label: "User Logins",
          icon: "user",
          url: this.route("admin.logs.logins.index"),
        },
        {
          label: "Tech Doc Views",
          icon: "book",
          url: this.route("admin.logs.documents.index"),
        },
        // {
        //   label: "eLearning Sessions",
        //   icon: "grad-cap",
        //   url: this.route("admin.logs.sessions.index"),
        // },
      ];
    },
  },
};
</script>